import Loadable from "react-loadable";

export const ReorderLink = Loadable({
  loader: () => import("../../../../modules/manage-posts").then((module) => module.ReorderLink) as Promise<any>,
  loading: () => null,
});
